import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/nnpp/imports')({
  component: Outlet,
})
